import React from 'react';
import Slider from 'react-slick';
import kilometer from '../../common/assets/images/kilometer.svg';
import setting from '../../common/assets/images/setting.svg';
import locationIcon from '../../common/assets/images/locationWithBase.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';
import { getCarinfoByVin } from '../../utils/api';

const SalvageCarInfo = ({ carDetail, setCompare, compare, setLoading, pageType }) => {
  const navigate = useNavigate();
  const { vin, title, state, city, images, seller_name, cylinders, odometer_mi, buy_now_price } = carDetail;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleComparison = (car, key) => {
    if (key === "add") {
      setCompare([...compare, car]);
      localStorage.setItem("compareSalvage", JSON.stringify([...compare, car]));
    }
    if (key === "remove") {
      let filteredData = compare.filter((item) => item?.vin !== car.vin)
      setCompare(filteredData);
      localStorage.setItem("compareSalvage", JSON.stringify(filteredData));
    }
  }
  return (
    <div
      style={{
        boxShadow: '1px 0px 12px 2px #57575733',
        border: '0.5px solid #7D7D7D',
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
    >
      <div className='slider-container min-h-[222px] findCardSlider relative'>
        {images[0] && <img src={JSON.parse(images[0])[0]} alt='' className='w-full object-fill max-h-[240px]' />}
        <div className='absolute top-[18px] right-[16px] rounded-[10px] flex items-center cursor-pointer'>
          <div className='absolute top-[8px] bg-white right-[4px] rounded-[10px] flex items-center cursor-pointer'>
            {compare.map((item) => item?.vin).includes(vin) ? <button className='border-2 px-[10px] py-[2px] rounded-[10px]' onClick={() => handleComparison(carDetail, "remove")}>Remove</button> : <>
              {compare.length < 4 && <button className='border-2 px-[10px] py-[2px] rounded-[10px]' onClick={() => handleComparison(carDetail, "add")}>Select</button>}
            </>
            }
          </div>
        </div>
      </div>

      <div className='w-full p-3  border-b-[0.5px] border-[#7D7D7D]'>
        <h2 className='font-semibold'>
          {title}
        </h2>
      </div>
      <div className='w-full p-3  border-b-[0.5px] border-l-[0.5px] border-[#7D7D7D] '>
        <h2 className='font-semibold'>Price: $ {buy_now_price ? buy_now_price : "not available"}</h2>
      </div>

      <div className='text-center p-3'>
        <div className='flex gap-2 pb-2'>
          <img src={kilometer} alt='' />
          <p className='text-sm'>{odometer_mi} Miles</p>
        </div>
        <div className='flex gap-2 pb-2'>
          <img src={setting} alt='' />
          <p className='text-sm'>{cylinders} Cylinders</p>
        </div>
        <div className='flex gap-2 pb-3'>
          <img src={locationIcon} alt='' />
          <p className='text-sm text-start'>
            {seller_name}, {city}, {state}
          </p>
        </div>
      </div>

      <div className='flex justify-center p-3'>
        <button
          className='darkBlue text-white py-3 mb-2 w-full rounded-xl font-medium'
          onClick={() => {
            navigate(`/product_page/${vin}?isSalvage=${pageType === "SalvageCars"}`, { state: { photoUrls: JSON.parse(images) } })
          }
          }
        >
          More Info
        </button>
      </div>
    </div>
  );
};

export default SalvageCarInfo;
